import { ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export const expendableFieldValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const isExpendable = control.get('isExpendable');
    const expirationDate = control.get('expirationDate');
    const numberOfParts = control.get('numberOfParts');

    return isExpendable && isExpendable.value &&
    ((expirationDate && !expirationDate.value) &&
    (numberOfParts && (!numberOfParts.value || numberOfParts.value <= 0))) ? { 'expendableInvalid': true } : null;
  };
